import { render, staticRenderFns } from "./YandexGpt.vue?vue&type=template&id=f3addc64&scoped=true"
import script from "./YandexGpt.vue?vue&type=script&lang=js"
export * from "./YandexGpt.vue?vue&type=script&lang=js"
import style0 from "./YandexGpt.vue?vue&type=style&index=0&id=f3addc64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3addc64",
  null
  
)

export default component.exports